import React from 'react';
import { motion } from 'framer-motion';
export function AudienceSection() {
  const audiences = ['Arquitectos', 'ITO', 'Ingenieros', 'Constructoras', 'Oficinas de inspección', 'Empresas de mantenimiento'];
  return <section className="py-16 sm:py-24 bg-gray-50" data-id="element-14">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-15">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4" data-id="element-16">
          ¿Para quién es InspectIA?
        </h2>
        <p className="text-lg text-gray-600 mb-10" data-id="element-17">
          Diseñado para profesionales que visitan obras y necesitan documentar
          lo que ven.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-wrap justify-center gap-3" data-id="element-18">
          {audiences.map((audience, index) => <span key={index} className="bg-white border border-gray-200 px-4 py-2 rounded-full text-sm font-medium text-gray-700 shadow-sm" data-id="element-19">
              {audience}
            </span>)}
        </motion.div>
      </div>
    </section>;
}